import { usePayments } from "../hooks/usePayments";
import TokenizationForm from "./TokenizationForm";
import Error from "./Error";

export default function Tokenization({ setCurrentBrand }) {
  const {
    customerId,
    agreementId,
    customerAgreements,
    bankList,
    status,
    isLoading,
  } = usePayments({ setCurrentBrand }); // custom hook

  return (
    <>
      {!isLoading ? (
        <>
          {customerAgreements.agreement_lines ? (
            <TokenizationForm
              customerId={customerId}
              agreementId={agreementId}
              customerAgreements={customerAgreements}
              bankList={bankList}
            />
          ) : (
            <Error
              customTitle={"NO ES POSIBLE AGREGAR MÉTODO DE PAGOS"}
              customMessage={"VERIFIQUE LOS DATOS"}
              errorCollection={status ? status : []}
            />
          )}
        </>
      ) : (
        <Error hasLoader />
      )}
    </>
  );
}
